import { useEffect } from "react";
import { Outlet, ScrollRestoration } from "react-router";
import {
  Layout,
} from "@inductiveautomation/ws-components";

import Navigation from "../../components/Navigation/Navigation";
import {
  retrieveAuthChannel,
  CHANNEL_MESSAGE_TYPES,
} from "../../utilities/broadcastChannel";

const Root = () => {
  const { authChannel } = retrieveAuthChannel();

  useEffect(() => {
    authChannel.onmessage = ({ data }) => {
      // only refresh the page to clear out the session if the tab is not in focus
      if (!document.hasFocus() && data === CHANNEL_MESSAGE_TYPES.LOGOUT) {
        window.location.reload();
      }
      // TODO: 3/21/2025 intentionally not closing the channel
      // this is the container for a lot of the routes
      // we should look into making it so that only the active page(s)
      // have a channel

      // also look into how we can push the user into the app if they login
      // from the public profile side, might not be doable as we can't put a
      // listener on the auth0 login page
    };
  }, [authChannel]);

  return (
    <Layout
      navigation={
        <>
          <ScrollRestoration />
          <Navigation />
        </>
      }
    >
      <Outlet />
    </Layout>
  );
};

export default Root;
